import { render, staticRenderFns } from "./ImagePhase.vue?vue&type=template&id=222edbfa&scoped=true&"
import script from "./ImagePhase.vue?vue&type=script&lang=js&"
export * from "./ImagePhase.vue?vue&type=script&lang=js&"
import style0 from "./ImagePhase.vue?vue&type=style&index=0&id=222edbfa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "222edbfa",
  null
  
)

export default component.exports